import { Component, inject } from '@angular/core';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreadcrumbItem } from '@core/types';
import { isMobileView } from '@core/utils';
import { PageHeaderComponent } from '@shared/components/ui/page-header/page-header.component';

@Component({
  selector: 'app-impressum',
  imports: [TranslateModule, PageHeaderComponent],
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss'],
})
export class ImpressumComponent {
  breadCrumbs: BreadcrumbItem[];
  protected readonly isMobileView = isMobileView();
  private readonly _translateService = inject(TranslateService);

  constructor() {
    const _translateService = this._translateService;

    this.breadCrumbs = !this.isMobileView
      ? [
          {
            label: _translateService.instant('Home'),
            link: '/',
          },
          {
            label: _translateService.instant('Impressum'),
          },
        ]
      : null;
  }
}
